"use client";

var _templateObject;
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
import styled from "styled-components";
var Divider = styled.hr.attrs({
  "data-mesh-component": "DIVIDER"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 0;\n  border: none;\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n"])));
Divider.displayName = "Divider";
export default Divider;